export default "__VITE_ASSET__B$E8KAY2__"